export type PartnerRequiredFields = {
  phone: boolean
}

export type SmartApplyPartnerConfig = {
  partnerId: string
  configurationId: string
  partnerFields: PartnerRequiredFields
}

export const smartApplyPartners = {
  adobeAcrobatPro: {
    partnerId: 'partner_000000CxmmOOgXcpEMhqfpe9h5XRA',
    configurationId: 'hostedconfiguration_000000D4CSgA8ZhbGj7hHA8ezaSvI',
    partnerFields: { phone: false }
  },
  adobeExpress: {
    partnerId: 'partner_000000CxmmOOgXcpEMhqfpe9h5XRA',
    configurationId: 'hostedconfiguration_000000Ct5bOHoi04ENRR7EKfDb2cx',
    partnerFields: { phone: false }
  },
  openai: {
    partnerId: 'partner_000000CkrkkKUg4D2mULQt9FsbYUS',
    configurationId: 'hostedconfiguration_000000CkrkkKUg4D2mULQt9FsbYUT',
    partnerFields: { phone: false }
  },
  zoom: {
    partnerId: 'partner_000000D2wBxPr8gVF485ywN1x51WK',
    configurationId: 'hostedconfiguration_000000D3RrzNoWCzM6UZKULiUpuTJ',
    partnerFields: { phone: false }
  },
  claude: {
    partnerId: 'partner_000000DD5SkAcBzB5NPinaUhbQg2y',
    configurationId: 'hostedconfiguration_000000DOY5FzKZ8e8VPby0uQKpoWG',
    partnerFields: { phone: true }
  }
} as const

/** Config keys (BE-bound) for every product submittable via smart apply. */
export type SmartApplyPartnerConfigKey = keyof typeof smartApplyPartners

/** Card-level partner identifiers shown in the smart-apply UI (Adobe is a single combined card). */
export type SmartApplyPartner = 'adobe' | 'adobeExpress' | 'openai' | 'zoom' | 'claude' | 'meta' | 'hootsuite'

export type SmartApplyApplyType = 'native' | 'external'

/**
 * How a partner card's Apply CTA behaves: 'native' submits to the backend (current default for
 * every partner); 'external' opens the partner's site. Add external partners here as they land.
 */
const smartApplyPartnerApplyTypes: Partial<Record<SmartApplyPartner, SmartApplyApplyType>> = {}

/** Resolves how a partner card's Apply CTA behaves, defaulting to native (backend submission). */
export function getSmartApplyPartnerApplyType(partner: SmartApplyPartner): SmartApplyApplyType {
  return smartApplyPartnerApplyTypes[partner] ?? 'native'
}

/** Returns just the BE-bound IDs for a partner, stripping FE-only `partnerFields` metadata. */
export function getSmartApplyPartnerConfigData(key: SmartApplyPartnerConfigKey): {
  partnerId: string
  configurationId: string
} {
  const { partnerId, configurationId } = smartApplyPartners[key]

  return { partnerId, configurationId }
}
